import { Probe } from "@/pages/heat-report/models/HeatReportModels";
import { getMomentTz } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef } from "ag-grid-enterprise";
const moment = getMomentTz();

export const useTableData = () => {
	const columns: ColGroupDef[] = [
		{
			headerName: "Probes",
			children: [
				{
					field: "Timestamp",
					headerName: "Time",
					flex: 1,
					minWidth: 61,
					valueGetter: (params: any) => {
						if (params.data.Timestamp) {
							return moment((params.data as Probe).Timestamp).format("HH:mm");
						}
					},
				},
				{
					field: "Temperature",
					headerName: "Temp",
					flex: 1,
					minWidth: 57,
				},
				{
					field: "Oxygen",
					headerName: "Oxygen",
					flex: 1,
					minWidth: 70,
				},
			],
		},
	];

	const defaultColDef: ColDef = {
		filter: false,
		floatingFilter: false,
		sortable: false,
		resizable: false,
		editable: false,
		suppressHeaderMenuButton: true,
	};

	return { columns, defaultColDef };
};
